import Model from '@models/model';

export default class UserAvailability extends Model {
    resource() {
        return 'user-availabilities';
    }
}
